var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02025 1.29252C0.753667 1.03853 0.753667 0.628172 1.02025 0.374185C1.28683 0.121144 1.71839 0.120196 1.98598 0.374185L5.79962 4.0409C6.06721 4.29488 6.06721 4.70619 5.79962 4.96018L1.98598 8.62689C1.71839 8.88088 1.28683 8.88088 1.02025 8.62689C0.753667 8.3729 0.753667 7.96254 1.02025 7.70856L4.14782 4.50054L1.02025 1.29252Z",
    fill: "#758698"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyRight);
export default __webpack_public_path__ + "static/media/grey-right.e2ccb3dce1b11f9eb4a6409f135a27b6.svg";
export { ForwardRef as ReactComponent };